<div class="location-info flex d-flex text-truncate">
  <div class="ortho-status location-info-text " *ngIf="statusOrtho && !discreteEnabled"
       [class.ortho-status-blue]="!statusOrthoFinal">
    <mat-icon matTooltip="{{statusOrthoTooltip}}" matTooltipClass="status-tooltip" class="white-icon"
              [class.colored-icon-preview]="!statusOrthoFinal">info_outline
    </mat-icon>
    <span class="status-padding">{{ statusOrtho }}</span>
  </div>
  <div class="ortho-status location-info-text " [class.ortho-status-blue]="measurementStatusPreview"
       *ngIf="availableMeasurementStatus()">
    <div class="stack-icon">
      <mat-icon class="stack-icon-bottom white-icon" matTooltipClass="status-tooltip"
                matTooltip="{{measurementStatusTooltip}}"
                svgIcon="measure"></mat-icon>
      <mat-icon class="stack-icon-top" matTooltipClass="status-tooltip" matTooltip="{{measurementStatusTooltip}}"
                *ngIf="!measurementStatusAvailable">block
      </mat-icon>
    </div>
    <span class="status-padding">{{ measurementStatus }}</span>
  </div>

  <div class="custom-attribution location-info-text" id="{{_target}}"></div>
  <div class="location-info-text zoom-text d-none d-lg-flex">
      Zoom: {{ zoom | number:'1.0-2' }}
  </div>
  <div class="location-info-text" *ngIf="visibleDate">Image Date {{ visibleDate }}</div>
  <div class="location-info-text d-none d-lg-flex" *ngIf="showLocationInfo()">
    {{ mapCenterCoordinates[1].toFixed(6) }},
    {{ mapCenterCoordinates[0].toFixed(6) }}
  </div>
</div>
